import { render, staticRenderFns } from "./customization.vue?vue&type=template&id=403b8b9f&scoped=true&"
import script from "./customization.vue?vue&type=script&lang=js&"
export * from "./customization.vue?vue&type=script&lang=js&"
import style0 from "./customization.vue?vue&type=style&index=0&id=403b8b9f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403b8b9f",
  null
  
)

export default component.exports